import { render } from "./Formato2015.vue?vue&type=template&id=0d710a81&scoped=true"
import script from "./Formato2015.vue?vue&type=script&lang=js"
export * from "./Formato2015.vue?vue&type=script&lang=js"

import "./Formato2015.vue?vue&type=style&index=0&id=0d710a81&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d710a81"]])

export default __exports__